module.exports = __webpack_public_path__ + "media/images/calendar-footer-5aea4f5f5f168d0e657b0a49a692af5e.svg";